export function attractionDetail() {
    $.fn.extend({
        toggleText: function (a, b) {
            return this.text(this.text() == b ? a : b);
        },
    });


    $('.main-slider').slick({
        speed: 500,
        slidesToShow: 1,
        dots: true,
        arrows: false,
        infinite: true,
        responsive: [
            {
                breakpoint: 666,
                settings: {
                    arrows: false,
                },
            },
        ],
        autoplay: true,
        autoplaySpeed:3000,
    });

    $('.tours-slider').slick({
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });

    $('.rentals-slider').slick({
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
        ],
    });

    $(function () {

        var annoucement = $('.announcement-bar').height();
        var top_space = 68 + annoucement;  // $('.page-link-holder').height()

        var linkArr = [];
        var topArr = [];
        $('.anchor-link').each(function () {
            var link = $(this).attr('href');
            if ($(link).length) {
                linkArr.push(link);
                topArr.push($(link).offset().top - top_space);
            } else {
                $(this).parent().remove();
            }
        });

        var timer;
        $(window).scroll(function () {
            if (timer) {
                window.clearTimeout(timer);
            }
            timer = window.setTimeout(function () {
                if (window.pageYOffset > topArr[0]) {
                    $('.page-links').addClass('sticky');
                } else {
                    $('.page-links').removeClass('sticky');
                }

                var active_section = '';
                for (var i = 0; i < topArr.length; i++) {
                    if (window.pageYOffset > topArr[i]) {
                        active_section = linkArr[i];
                    }
                }

                $('.page-link-holder ul li a').each(function () {
                    $(this).removeClass('active');
                    if ($(this).attr('href') == active_section) {
                        $(this).addClass('active');
                    }
                });
            }, 10);
        });

        $('.anchor-link').on('click', function (event) {
            event.preventDefault();
            var id = $(this).attr('href');
            var top = $(id).offset().top - top_space + 2;
            $('html, body').animate({ scrollTop: top }, 500);
        });

        $('.main-slider-wrapper .prev').click(function () {
            $('.main-slider').slick('slickPrev');
        });
        $('.main-slider-wrapper .next').click(function () {
            $('.main-slider').slick('slickNext');
        });

        $('.show-more-button').click(function () {
            $(this).parents('.content-holder').toggleClass('passive');
            $(this).toggleText('Show more', 'Show less');
        });

        $('.tours-slider-wrapper .prev').click(function () {
            $('.tours-slider').slick('slickPrev');
        });
        $('.tours-slider-wrapper .next').click(function () {
            $('.tours-slider').slick('slickNext');
        });

        $('.rentals-slider-wrapper .prev').click(function () {
            $('.rentals-slider').slick('slickPrev');
        });
        $('.rentals-slider-wrapper .next').click(function () {
            $('.rentals-slider').slick('slickNext');
        });
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/attractionDetail.js